import {
  ColumnType,
  getDayjs,
  InputDataType,
  ISODate,
} from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './utils.translations.json';

const { addTranslations, t } = i18nNsFactory('input-data-table-utils');
addTranslations(translations);

export const COLUMN_SEQUENCE_NO = 'sequenceNumber';
export const COLUMN_SUBJECT = 'SUBJEKT';

const MAX_INTEGER_DIGITS = 18;
const MAX_DECIMAL_DIGITS = 10;

export function adjustColumns(data: InputDataType, isDetailed?: boolean) {
  const columns: ColumnType[] = [
    {
      code: 'sequenceNumber',
      name: t('sequence-no'),
      type: 'number',
      hidden: false,
    },
    ...data.columns,
  ];

  if (isDetailed) {
    columns
      .filter((column) => column.code === COLUMN_SUBJECT)
      .forEach((column) => (column.hidden = true));
  }

  return columns;
}

export function getNumberConstraints(decimals?: number | null) {
  const configuredPrecision =
    decimals != null && Number.isInteger(decimals) && decimals >= 0
      ? decimals
      : MAX_DECIMAL_DIGITS;
  const precision = Math.min(configuredPrecision, MAX_DECIMAL_DIGITS);
  const integerPart = '9'.repeat(MAX_INTEGER_DIGITS);
  const max = precision
    ? `${integerPart}.${'9'.repeat(precision)}`
    : integerPart;

  return { min: `-${max}`, max, precision };
}

export function isDateBetween(
  date?: ISODate | null,
  from?: ISODate | null,
  to?: ISODate | null,
) {
  if (!date || (!from && !to)) {
    return true;
  }

  const dateTime = getDayjs(date);
  const fromTime = getDayjs(from);
  const toTime = getDayjs(to);

  if (fromTime && fromTime.isAfter(dateTime)) {
    return false;
  }
  return !(toTime && toTime.isBefore(dateTime));
}
